"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiInputAdornmentOverrides = function (_a) {
    var spacing = _a.spacing, palette = _a.palette;
    return ({
        root: {
            height: undefined,
            maxHeight: undefined,
            fontSize: "inherit",
            lineHeight: 1.4,
            color: palette.text.secondary,
        },
        positionStart: {
            marginRight: undefined,
            paddingLeft: spacing(4),
            // Input with a label and adornments
            ".MuiInputLabel-root + .MuiInputBase-root > &": {
                alignSelf: "flex-end",
                paddingBottom: spacing(2),
            },
        },
        positionEnd: {
            marginLeft: undefined,
            paddingRight: spacing(4),
            ".MuiSelect-root ~ &": {
                paddingRight: "unset",
                position: "absolute",
                right: spacing(9),
            },
        },
    });
};
//# sourceMappingURL=MuiInputAdornment.js.map